/*
 * @Description:
 * @Date: 2019-05-22 13:51:34
 */
// 存放page HOME 统一使用参数
import { projectAllList } from '@/config/staticData.js';
import { setStorage } from '@/tools/storage';
const moudle = (basePath, name) => {
  return {
    editName: `${basePath}Detail`,
    recordName: `${basePath}Record`,
    assignName: `${basePath}Tast`,
    projectTypeName: name
  };
};
const projectObj = {};
projectAllList.filter((item, index) => {
  projectObj[index] = moudle(item.filePath, item.name);
});
const homeProject = {
  state: {
    projectType: '', // 项目类型 1学术拜访 2 OTC巡访 3 科室会 4 患教会 5助手端项目调研 6线上推广 7医生端调查问卷 8医生病历  9 等级医院拜访  10基层医疗机构拜访 11 特级三甲医院市场准入  12 三级医院市场准入  13 二级医院市场准入  14 基层医疗机构市场准入 15 零售药店市场准入 17数字拜访 18助手病历征集 19协定服务 20可配场景
    projectName: '',
    id: '',
    editName: '', // 编辑显示组件
    recordName: '', // 记录组件
    assignName: '', // 分配组件
    projectTypeName: '', // 对应项目名称
    activeName: '',
    projectStructureType: '', //新增项目类型，1代表四级结构，2代表三级个体，3代表三级个人
    fileUpMode: 0, // 1活动维度 2人维度
    fileUpSource: 0 // 1ASP上传 2C上传 3双方上传
  },

  mutations: {
    SET_ACTIVENAME: (state, item) => {
      state.activeName = item;
    },
    SET_HOME_QUERY: (state, item) => {
      item = { ...state, ...item };
      const {
        projectType,
        projectName,
        id,
        serviceSubitem,
        projectStructureType,
        type,
        fileUpMode,
        fileUpSource
      } = item;
      const { editName, recordName, assignName, projectTypeName } = projectObj[
        item.projectType - 1
      ];
      state = Object.assign(state, {
        projectType,
        projectName,
        id,
        type,
        projectStructureType,
        editName,
        recordName,
        assignName,
        serviceSubitem,
        projectTypeName: projectType == 20 ? serviceSubitem : projectTypeName,
        fileUpMode,
        fileUpSource
      });
      setStorage('homeProject', {
        id: item.id,
        type,
        projectType: item.projectType,
        projectName: item.projectName,
        projectStructureType,
        serviceSubitem,
        projectTypeName: projectType == 20 ? serviceSubitem : projectTypeName,
        fileUpMode,
        fileUpSource
      });
    },
    CLEAN_HOME: (state, item) => {
      Object.keys(state).filter(key => {
        if (key !== 'activeName') {
          state[key] = '';
        }
      });
      localStorage.homeProject = '';
    }
  },
  actions: {
    setHomeQuery({ commit, state }, item) {
      commit('SET_HOME_QUERY', item);
    },
    setActivename({ commit, state }, item) {
      commit('SET_ACTIVENAME', item);
    }
  }
};

export default homeProject;
